import * as UserActions from './../actions/user_actions';
import * as QuestionnaireActions from './../actions/questionnaire_actions';
import extend from 'lodash/extend';
import _ from 'lodash';


export var Questionnaire = (state = {

    QuestionnaireData: null,
    AnswerType: null,
    CreateUniqueData: null,
    QuestionUpdate: null,
    PatientGetAllUniqueQuestion: null


}, action) => {
    switch (action.type) {
        // // Uncomment below block only if you want to persist store data
        case 'persist/REHYDRATE': {
            if (action.payload.Questionnaire) {
                action.payload.Questionnaire.IsLoggingIn = false;
            } else {
                return state;
            }
        }

        case QuestionnaireActions.QUESTIONNAIRE_DATA:
            {

                let daily = _.filter(action.data, { type: "DAILY" });
                let weekly = _.filter(action.data, { type: "WEEKLY" });
                let unique = _.filter(action.data, { type: "UNIQUE" });

                unique.reverse();

                return extend({}, state, {
                    QuestionnaireData: action.data,
                    QuestionnaireDaily: daily,
                    QuestionnaireWeekly: weekly,
                    QuestionnaireUnique: unique

                });
            }
            break;

        case QuestionnaireActions.QUESTIONNAIRE_DETAILS_FAIL:
            {
                return extend({}, state, { QuestionnaireData: action.data });
            }
            break;

        case QuestionnaireActions.ANSERTYPE_DATA:
            {

                return extend({}, state, {
                    AnswerType: action.data
                });

            }
            break;

        case QuestionnaireActions.ANSERTYPE_DETAILS_FAIL:
            {
                return extend({}, state, { AnswerType: action.data });
            }
            break;

        case QuestionnaireActions.CREATE_UNIQUE_DATA:
            {
                return extend({}, state, { CreateUniqueData: action.data });
            }
            break;

        case QuestionnaireActions.CREATE_UNIQUE_FAIL:
            {
                return extend({}, state, { CreateUniqueData: action.data });
            }
            break;

        case QuestionnaireActions.QUESTIONS_UPDATE_DATA:
            {
                return extend({}, state, { QuestionUpdate: action.data });
            }
            break;

        case QuestionnaireActions.QUESTIONS_UPDATE_FAIL:
            {
                return extend({}, state, { QuestionUpdate: action.data });
            }
            break;
        case UserActions.USER_LOG_OUT: {

            return extend({}, state, {
                QuestionnaireData: null,
                AnswerType: null,
                CreateUniqueData: null,
                QuestionUpdate: null,
                QuestionnaireDaily: null,
                QuestionnaireWeekly: null,
                QuestionnaireUnique: null
            })
        }
            break;
        case QuestionnaireActions.GET_ALL_UNIQUE_QS:
            {
                return extend({}, state, { PatientGetAllUniqueQuestion: action.data });
            }
            break;
        default:
            return state;
    }
};



/** WEBPACK FOOTER **
 ** ./src/reducers/questionnaire_reducer.js
 **/